export const QA_NAME_MINIMIZED_MODALS_TRAY = 'MinimizedModalsTray'
